<template>
  <div class="shares" v-loading="loading">
    <template v-if="isEmpty && !loading">
      <div class="shares-empty">
        <img :src="require(`@/assets/empty.svg`)" class="shares-empty__icon" width="256" alt="share link is empty">
        <div class="shares-empty__title" v-text="$t('shares.msg_empty_title')"></div>
        <div class="shares-empty__label" v-html="$t('shares.msg_empty_text')"></div>
      </div>
    </template>
    <template v-else-if="isAvailable">      
      <Preview v-if="previewStatus" />
      <FileList v-else />
    </template>
    <div v-else class="shares-unavaiable">
      <span class="shares-unavaiable__text" v-text="unavaiableText"></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FileList from '@/components/file'
import Preview from '@/components/preview'

export default {
  name: 'Shares',
  components: {
    Preview,
    FileList
  },
  data() {
    return {
      loading: false,
      isEmpty: false,
      isAvailable: true,
      unavaiableText: ''
    }
  },
  computed: {
    ...mapGetters([
      'previewStatus',
      'previewFile',
      'currentStore'
    ])
  },
  watch: {
    $route(to, from) {
      if (!to.params.filename && from.params.filename) {
        this.$store.commit('REMOVE_PREVIEW_FILE')
      } else if (to.params.filename) {
        const file = this.currentStore.find(({ name }) => name == to.params.filename)

        if (!this.previewStatus || (file && file.id != this.previewFile.id)) {
          this.$store.commit('INIT_PREVIEW', file)
        }
      }
    }
  },
  created() {
    this.$store.commit('RESET_FILES_STATE')
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const { shareId, filename } = this.$route.params

      this.loading = true
      
      this.$store.dispatch('GET_FILES_BY_SHAREID', shareId).then(() => {
        this.loading = false
        window.clevertap.event.push('LMS Link viewed')

        if (!this.currentStore.length) {
          this.isEmpty = true

          return false
        }

        if (filename) {
          const file = this.currentStore.find(({ name }) => name == filename)

          if (file) {
            this.$store.commit('INIT_PREVIEW', file)
          } else {
            this.$router.push(`/shares/${shareId}`)
          }
        } else if (this.currentStore.length == 1) {
          this.$store.commit('INIT_PREVIEW', this.currentStore[0])
        }
      }).catch(({ code, message }) => {
        this.loading = false
        this.isAvailable = false
        this.unavaiableText = this.$t(`preview.msg_${code == 404 ? 'not_found' : 'expired'}`)

        if (code == 404) {
          message = this.$t('preview.msg_share_not_found')
        }

        if (message) {
          this.$message.error({
            message,
            showClose: true,
            duration: 10 * 1000
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');

  .shares {
    flex: 1;
    overflow: hidden;
    background-color: var(--background-color, @grey-100);
    & &-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 0 16px;
      text-align: center;
      line-height: 24px;
      &__icon {
        max-width: 100%;
        margin-bottom: 24px;
      }
      &__title {
        color: var(--title-color, #000);
        font-weight: 500;
        font-size: 24px;
        letter-spacing: 0.15px;
        margin-bottom: 16px;
      }
      &__label {
        color: @grey-600;
        font-size: 16px;
        letter-spacing: 0.15px;
      }
    }
    & &-unavaiable {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding: 0 16px;
      &__text {
        display: inline-block;
        border-radius: 5px;
        font-size: 16px;
        font-weight: bold;
        padding: 12px 18px;
        color: var(--title-color, @black);
        background-color: var(--background-contrl, @white);
      }
    }
  }
</style>